<script lang="ts" setup>
import LeCheckmark from "@dsk/icons/LeCheckmark.vue";
</script>

<template>
  <li class="le-usp-item">
    <LeCheckmark class="le-usp-item__icon" />
    <span class="le-usp-item__text"><slot /></span>
  </li>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-usp-item {
  display: flex;
  gap: 12px;
  align-items: center;
  .body-text("s");

  &__icon {
    flex-shrink: 0;
  }

  &__text {
    padding: 8px;
  }
}
</style>
